module.exports = __webpack_public_path__ + "static/media/photo.57d21bde.svg";